import angular from 'angular';
/*
JSON.stringify doesn't work on Error object
https://stackoverflow.com/a/18391400
 */
const replaceErrors = (key, value) => {
  if (value instanceof Error) {
    var error = {};

    Object.getOwnPropertyNames(value).forEach(function(propName) {
      error[propName] = value[propName];
    });

    return error;
  }

  return value;
};

angular.module('cloudX').factory('$exceptionHandler', [
  'appInsights',
  function(appInsights) {
    return function errorCatcherHandler(exception, cause) {
      if (!exception) return;
      console.error(exception, cause);

      if (appInsights) {
        try {
          if (exception instanceof Error) {
            appInsights.trackException(
              { exception },
              {
                cause: JSON.stringify(cause),
              },
            );
          } else {
            const errorMessage = exception?.toString();
            appInsights.trackException(
              { exception: new Error(errorMessage || 'Unknown JS error') },
              {
                originalError: JSON.stringify(exception, replaceErrors),
                cause: JSON.stringify(cause),
              },
            );
          }
        } catch (e) {
          console.warn(e);
        }
      }
      // do not rethrow the exception - breaks the digest cycle
    };
  },
]);
